import { render, staticRenderFns } from "./veSbzcZcRevertEdit.vue?vue&type=template&id=ddda3db0&scoped=true"
import script from "./veSbzcZcRevertEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcRevertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda3db0",
  null
  
)

export default component.exports